/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SimpleChanges, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SendIconComponent } from 'src/chatbot/icons/send-icon/send-icon.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
  selector: 'send-button',
  standalone: true,
  imports: [
    CommonModule,
    SendIconComponent
  ],
  templateUrl: './sendButton.component.html',
  styleUrl: './sendButton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SendButtonComponent {
  public dataChat = inject(DataChatService);
  public isInvalid = signal<boolean>(true)

  @Input() chatForm!: FormGroup;

  ngOnInit(){
    this.isInvalid.set(this.chatForm.invalid);
    this.chatForm.valueChanges.subscribe(() => {
      this.isInvalid.set(this.chatForm.invalid)
    });
  }

 }
